import { Injectable } from "@angular/core";
import {
  IArticleMetadata,
  IDocumentConversionResponse,
  IKnowledgeDocumentService,
  IMediaUploadResponse,
  IStyleGuideResult,
} from "@comunicare/comunicare-angular-interfaces";
import { Observable } from "rxjs";
import { ApiService } from "./api.service";

/**
 * Document features of the knowledge editor and list (KNOWLEDGE_DOCUMENT_SERVICE): DOCX import, media upload and analyses.
 * Not a BaseApiService: these routes have no permission of their own, the server checks dashboard/knowledge (POST for the
 * DOCX import, PUT for the others). Errors follow the contract of IKnowledgeDocumentService (see HttpErrorInterceptor).
 */
@Injectable({
  providedIn: "root",
})
export class KnowledgeDocumentApiService implements IKnowledgeDocumentService {
  constructor(private api: ApiService) {}

  public convertDocx(file: File): Observable<IDocumentConversionResponse> {
    return this.api.post("dashboard/knowledge/convertDocx", this.fileForm(file), null, true) as Observable<IDocumentConversionResponse>;
  }

  public uploadMedia(file: File): Observable<IMediaUploadResponse> {
    return this.api.post("dashboard/knowledge/uploadMedia", this.fileForm(file), null, true) as Observable<IMediaUploadResponse>;
  }

  public extractMetadata(html: string): Observable<IArticleMetadata> {
    return this.api.post("dashboard/knowledge/extractMetadata", { html }) as Observable<IArticleMetadata>;
  }

  public checkStyleGuide(html: string): Observable<IStyleGuideResult> {
    return this.api.post("dashboard/knowledge/checkStyleGuide", { html }) as Observable<IStyleGuideResult>;
  }

  private fileForm(file: File): FormData {
    const formData = new FormData();
    formData.append("file", file, file.name);
    return formData;
  }
}
